import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import axios from "../../utils/axiosInstance"; 
import Button from "components/CustomButtons/Button.js";
import { useHistory, useParams } from "react-router-dom";
import ApproveModal from "./ApproveModal";
import RejectModal from "./RejectModal";
import "../../assets/css/styles.css"
export default function approveWithdrawReq() {
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  };
  const [openReject, setOpenReject] = useState(false);
  const handleClickOpenReject = () => setOpen(true);
  const handleCloseReject = () => {
    setOpen(false);
  };
  const [withdrawDetail, setWithdrawDetail] = useState({});
  let { paymentId } = useParams();
  useEffect(() => {
    getData(paymentId);
  }, []);
  const getData = async (paymentId) => {
    const token = localStorage.getItem("token");
    console.log(token);
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/userWithdrawRequest?paymentId=${paymentId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
      }
    );
    const data = res.data.data[0].withdrawData;
    setWithdrawDetail(data);
  };
  return (
    <div style={{ paddingRight: "200px", paddingLeft: "100px" }}>
      <div className="App">
        <header className="App-header">
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Payout of prizemoney</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    Date
                  </TableCell>
                  <TableCell align="right">
                    {withdrawDetail.initiated}
                  </TableCell>
                </TableRow>
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    Transaction Number
                  </TableCell>
                  <TableCell align="right">
                    {withdrawDetail.transactionsId}
                  </TableCell>
                </TableRow>
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    User Name
                  </TableCell>
                  <TableCell align="right">{withdrawDetail.player}</TableCell>
                </TableRow>
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    Lottery Name
                  </TableCell>
                  <TableCell align="right">
                    {withdrawDetail.lotteryName}
                  </TableCell>
                </TableRow>
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    KYC Successfull
                  </TableCell>
                  <TableCell align="right">
                    {withdrawDetail.kycStatus}
                  </TableCell>
                </TableRow>
                {/* <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    Method
                  </TableCell>
                  <TableCell align="right">
                    {withdrawDetail.transferMethod}
                  </TableCell>
                </TableRow> */}
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    Prize Money Amount
                  </TableCell>
                  <TableCell align="right">{withdrawDetail.amount}</TableCell>
                </TableRow>
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    Commission Amount (20%)
                  </TableCell>
                  <TableCell align="right">
                    {withdrawDetail.commissionAmount}
                  </TableCell>
                </TableRow>
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    Payout Amount (80%)
                  </TableCell>
                  <TableCell align="right">
                    {withdrawDetail.payoutAmount}
                  </TableCell>
                </TableRow>
                {/* <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    Rate
                  </TableCell>
                  <TableCell align="right">{withdrawDetail.rate}</TableCell>
                </TableRow>
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    Payable
                  </TableCell>
                  <TableCell align="right">{withdrawDetail.payable}</TableCell>
                </TableRow> */}
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    Status
                  </TableCell>
                  <TableCell align="right">{withdrawDetail.status}</TableCell>
                </TableRow>
                <div style={{ margin: "17px 0 10px 200px" }}>
                  <Button
                    className="button-41"
                    onClick={() => {
                      setOpen(true);
                    }}
                  >
                    Approve
                  </Button>
                  <Button
                    className="button-42"
                    onClick={() => {
                      setOpenReject(true);
                    }}
                  >
                    Reject
                  </Button>
                </div>
              </TableBody>
            </Table>
          </TableContainer>
        </header>
      </div>
      <ApproveModal
        open={open}
        setOpen={setOpen}
        handleClickOpen={handleClickOpen}
        handleClose={handleClose}
        paymentId={withdrawDetail.paymentId}
        transectionId={withdrawDetail.transactionsId}
        amount={withdrawDetail.payoutAmount}
      />
      <RejectModal
        open={openReject}
        setOpen={setOpenReject}
        handleClickOpen={handleClickOpenReject}
        handleClose={handleCloseReject}
        paymentId={withdrawDetail.paymentId}
        transectionId={withdrawDetail.transactionsId}
      />
    </div>
  );
}
